import { Environment } from "@octopusdeploy/utilities";
import { useOctopusFeatureToggle } from "~/hooks/useOctopusFeatureToggle";
import { useUIOnlyFeatureFlag } from "~/hooks/useUIOnlyFeatureFlag";
export function useIsVerticalNavigationEnabled(): boolean {
    const { isFeatureEnabled } = useVerticalNavigationFeature();
    return isFeatureEnabled;
}
export function useVerticalNavigationFeature() {
    const [isVerticalNavigationDisabled, setIsVerticalNavigationDisabled] = useUIOnlyFeatureFlag("Disable Vertical Navigation", { isInitiallyEnabled: false, scope: "machine" });
    const isOctopusFeatureToggleEnabled = useOctopusFeatureToggle("vertical-navigation", false);
    const featureConfiguredAsEnabled = Environment.isInDevelopmentMode() || isOctopusFeatureToggleEnabled;
    const isFeatureEnabled = !isVerticalNavigationDisabled && featureConfiguredAsEnabled;
    const showUIFeatureFlagToggle = featureConfiguredAsEnabled;
    return {
        isFeatureEnabled,
        isUIFeatureFlagEnabled: isVerticalNavigationDisabled,
        showUIFeatureFlagToggle,
        setUIFeatureFlagEnabled: setIsVerticalNavigationDisabled,
    };
}
